import React, { useEffect } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { activateAuthLayout } from '../../../store/actions';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import { useOktaAuth } from '@okta/okta-react';
import QuotesTable from '../../../components/quotes/QuotesTable';

const QUOTES = gql`
  query getQuotes($CreatedBy: String) {
    Quotes(CreatedBy: $CreatedBy) {
      QuoteId
      ProposalNumber
      CompanyName
      Description
      Status
      WorkflowStep
      QuoteTypeId1
      QuoteTypeId2
      QuoteType1 {
        Name
      }
      QuoteType2 {
        Name
      }
      Created
      ModifiedTimestamp
    }
  }
`;

const MyQuotes = ({ activateAuthLayout }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);
  const { authState } = useOktaAuth();
  const { data, refetch } = useQuery(QUOTES, { variables: { CreatedBy: authState?.idToken?.claims?.email } });

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="page-title-box">
          <Row className="align-items-center">
            <Col sm="6"><h4 className="page-title">My Quotes</h4></Col>
          </Row>
        </div>
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <QuotesTable quotes={data?.Quotes} refetch={refetch} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default connect(null, { activateAuthLayout })(MyQuotes);
